var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    {
      staticClass: "stretch-grid position-relative",
      attrs: { id: "documents-page" }
    },
    [
      _vm.$p(["ADMIN", "MANAGER"], "or")
        ? _c("DocumentUpload", {
            attrs: { hideEntity: true, entityItemId: _vm.currentManagerId }
          })
        : _vm._e(),
      _vm.$p(["ADMIN"]) && _vm.currentManagerId
        ? _c("DocumentGrid", {
            attrs: {
              entityItemId: _vm.currentManagerId,
              documentTypeId: _vm.documentTypeId,
              deletable: true,
              pagination: _vm.pagination
            }
          })
        : _vm.$p(["MANAGER", "RECRUITER", "AFFILIATE", "INSTRUCTOR"], "or") &&
          _vm.managerOptionIds.length > 0
          ? _c("DocumentGrid", {
              attrs: {
                entityItemIds: _vm.managerOptionIds,
                documentTypeId: _vm.documentTypeId,
                deletable: true,
                pagination: _vm.pagination
              }
            })
          : _vm._e(),
      !_vm.currentManagerId
        ? _c(
            "div",
            {
              staticClass: "text-weight-bold",
              staticStyle: {
                position: "absolute",
                left: "0",
                width: "100%",
                top: "50%"
              }
            },
            [
              _c("p", { staticClass: "text-center text-primary" }, [
                _vm._v("Admin, Please select a Manager to see their documents.")
              ]),
              _c(
                "p",
                [
                  _vm.$p(["ADMIN"])
                    ? _c("q-select", {
                        staticStyle: {
                          "max-width": "300px",
                          width: "300px",
                          margin: "0 auto"
                        },
                        attrs: {
                          "float-label": "Select Manager",
                          value: _vm.currentManagerId,
                          options: _vm.managerOptions,
                          before: [{ icon: "fa fa-users" }],
                          filter: "",
                          "autofocus-filter": ""
                        },
                        on: {
                          input: function(val) {
                            return _vm.updateManagerSelectHandler(val)
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm.youtubeLinks.length > 0
        ? _c(
            "div",
            { attrs: { id: "links" } },
            [
              _c(
                "h6",
                [
                  _c("q-icon", {
                    attrs: {
                      size: "22px",
                      color: "primary",
                      name: "fa fa-youtube-play"
                    }
                  }),
                  _vm._v(" Video Tutorials")
                ],
                1
              ),
              _c(
                "q-list",
                { staticClass: "scroll-pane" },
                _vm._l(_vm.youtubeLinks, function(yt, i) {
                  return _c(
                    "q-item",
                    {
                      key: i,
                      nativeOn: {
                        click: function($event) {
                          _vm.openLink(yt)
                        }
                      }
                    },
                    [
                      _c("q-item-side", { attrs: { image: yt.thumb } }),
                      _c(
                        "q-item-main",
                        [
                          _c("q-item-tile", { attrs: { label: "" } }, [
                            _vm._v(_vm._s(yt.title))
                          ]),
                          _c(
                            "q-item-tile",
                            { attrs: { label: "" } },
                            [
                              _c(
                                "q-btn",
                                {
                                  staticStyle: { "margin-top": "5px" },
                                  attrs: {
                                    color: "grey-3",
                                    "text-color": "grey-9",
                                    size: "sm"
                                  }
                                },
                                [_vm._v("View")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                })
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "q-layout-footer",
        [
          _c(
            "q-toolbar",
            [
              _c("q-toolbar-title", [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-4" },
                    [
                      _vm.$p(["ADMIN"])
                        ? _c("q-select", {
                            attrs: {
                              "float-label": "Manager",
                              value: _vm.currentManagerId,
                              options: _vm.managerOptions,
                              before: [{ icon: "fa fa-users" }],
                              filter: "",
                              "autofocus-filter": ""
                            },
                            on: {
                              input: function(val) {
                                return _vm.updateManagerSelectHandler(val)
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ]),
              _vm.currentManagerId
                ? _c("q-btn", {
                    attrs: { label: "Upload", color: "green" },
                    on: {
                      click: function($event) {
                        _vm.openUploadModal()
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }